(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-also-bought"]) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (section.dataset.customerAlsoBoughtInitialized === 'true') return;

      const track = section.querySelector('[data-customer-also-bought-track]');
      const previous = section.querySelector('[data-customer-also-bought-previous]');
      const next = section.querySelector('[data-customer-also-bought-next]');

      if (!track || !previous || !next) return;

      section.dataset.customerAlsoBoughtInitialized = 'true';

      // 箭头按一屏翻页，落点仍对齐卡片边界
      const scrollAmount = () => {
        const cards = track.querySelectorAll('.grid__item');
        if (!cards.length) return track.clientWidth;
        const step = cards.length > 1
          ? cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left
          : cards[0].getBoundingClientRect().width;
        if (step <= 0) return track.clientWidth;
        const perView = Math.max(1, Math.floor(track.clientWidth / step));
        return perView * step;
      };

      const updateButtons = () => {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      };

      previous.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      new ResizeObserver(updateButtons).observe(track);
      updateButtons();
    };

    document.querySelectorAll('[data-customer-also-bought]').forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-customer-also-bought]');
      if (section) initialize(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // 点击箭头滚动约一屏的 80%，留一点重叠方便对照
    const ARROW_STEP_RATIO = 0.8;

    // 祖先元素上的 transform/filter/perspective 会成为 fixed 定位的包含块
    // （吸顶头部滚动时就是这种情况），需要把窗口坐标换算到该包含块
    const fixedOriginOf = (element) => {
      let node = element.parentElement;

      while (node && node !== document.documentElement) {
        const style = getComputedStyle(node);
        if (style.transform !== 'none' || style.filter !== 'none' || style.perspective !== 'none') {
          const rect = node.getBoundingClientRect();
          return { x: rect.left, y: rect.top };
        }
        node = node.parentElement;
      }

      return { x: 0, y: 0 };
    };

    const initialize = (scroller) => {
      if (scroller.dataset.navScrollerInitialized === 'true') return;

      const viewport = scroller.querySelector('[data-nav-scroller-viewport]');
      const previous = scroller.querySelector('[data-nav-scroller-previous]');
      const next = scroller.querySelector('[data-nav-scroller-next]');

      if (!viewport || !previous || !next) return;

      scroller.dataset.navScrollerInitialized = 'true';

      const maxScroll = () => viewport.scrollWidth - viewport.clientWidth;

      const updateArrows = () => {
        const scrollable = maxScroll() > 1;
        previous.disabled = !scrollable || viewport.scrollLeft <= 1;
        next.disabled = !scrollable || viewport.scrollLeft >= maxScroll() - 1;
      };

      let openItem = null;

      const positionDropdown = (item) => {
        const dropdown = item.querySelector('.site-nav__dropdown');
        if (!dropdown) return;

        const origin = fixedOriginOf(dropdown);
        const itemRect = item.getBoundingClientRect();
        const pageWidth = document.documentElement.clientWidth;

        dropdown.style.top = `${itemRect.bottom - origin.y}px`;

        if (dropdown.classList.contains('megamenu')) {
          dropdown.style.left = `${-origin.x}px`;
          dropdown.style.width = `${pageWidth}px`;
          return;
        }

        // 先在最宽可用空间里量出自然宽度，再与触发项左对齐并收进窗口内
        dropdown.style.minWidth = `${itemRect.width}px`;
        dropdown.style.left = '0px';
        const left = Math.min(itemRect.left, pageWidth - dropdown.offsetWidth);
        dropdown.style.left = `${Math.max(0, left) - origin.x}px`;
      };

      const repositionOpenDropdown = () => {
        if (openItem) positionDropdown(openItem);
      };

      scroller.querySelectorAll('.site-nav--has-dropdown').forEach((item) => {
        // click 用于触屏，theme.js 在触屏上是首次点击展开
        ['mouseenter', 'focusin', 'click'].forEach((eventName) => {
          item.addEventListener(eventName, () => {
            openItem = item;
            positionDropdown(item);
          });
        });

        item.addEventListener('mouseleave', () => {
          if (openItem === item) openItem = null;
        });
      });

      previous.addEventListener('click', () => {
        viewport.scrollBy({ left: -viewport.clientWidth * ARROW_STEP_RATIO, behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        viewport.scrollBy({ left: viewport.clientWidth * ARROW_STEP_RATIO, behavior: 'smooth' });
      });

      viewport.addEventListener('scroll', () => {
        updateArrows();
        repositionOpenDropdown();
      }, { passive: true });

      window.addEventListener('scroll', repositionOpenDropdown, { passive: true });

      new ResizeObserver(() => {
        updateArrows();
        repositionOpenDropdown();
      }).observe(viewport);

      updateArrows();
    };

    document.querySelectorAll('[data-nav-scroller]').forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-nav-scroller]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
